import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';

import { useConversationPrivacyContent } from 'src/constants';
import { Conversation } from 'src/types/conversation';

import styles from './ConversationPrivacyLabel.module.scss';

interface Props {
  conversation: Conversation;
  className?: string;
  iconOnly?: boolean;
  iconSize?: 'xs' | 'sm';
}

const ConversationPrivacyLabel = ({
  className,
  conversation,
  iconOnly,
  iconSize,
}: Props) => {
  let { privacy_level: privacyLevel } = conversation;

  // if the conversation is from the app, it is protected
  // https://github.com/CorticoAI/cortico-platform/pull/4800/files/fec739c1ab233c94b12395c20d8668a8ead572c5#r2356786461
  if (conversation.source_id === 'app') {
    privacyLevel = 'protected';
  }

  const { title, icon } = useConversationPrivacyContent()[privacyLevel];
  const fullTitle = title('Conversation');

  return (
    <div
      className={className}
      data-testid="conversation-privacy-label"
      role="img"
      aria-label={fullTitle}
    >
      <span
        className="position-relative"
        aria-hidden={!iconOnly}
        title={fullTitle}
        data-testid={`${fullTitle}-icon`}
      >
        <FontAwesomeIcon
          icon={icon}
          className={`text-${privacyLevel}`}
          size={iconSize}
        />
      </span>{' '}
      {!iconOnly && (
        <span className={cx(styles.title, 'ps-1')}>{fullTitle}</span>
      )}
    </div>
  );
};

export default ConversationPrivacyLabel;
